import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { RESOURCES, USER_RESOURCE_ENDPOINT } from './endpoints';

const actions = createActions({
  USER: {
    GET_QUALIFICATIONS: () => ({}),
    API: {
      GET_QUALIFICATIONS: apiResourceActionCreator('qualifications')
    }
  }
})

export const apiAction = (authToken) => commonApiActions.authenticated.get(USER_RESOURCE_ENDPOINT(RESOURCES.Qualification), authToken, actions.user.api.getQualifications)

export function* getQualifications() {
  const authToken = yield select(authTokenSelector);

  if (authToken.idToken) {
    yield put(apiAction(authToken));
  }
}

const configuration = {
  name: 'getQualifications',
  action: actions,
  sagas: getQualifications,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetchingQualifications: true
    }),
    success: (state, action) => ({
      ...state,
      qualifications: action.payload.qualifications,
      isFetchingQualifications: false
    }),
    failed: (state, action) => ({
      ...state,
      isFetchingQualifications: false
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/getQualifications.js